export default __webpack_public_path__ + "static/media/223.76e13da9.jpg";